<div *ngFor="let t of toasts">
  <app-toast-message [message]="t.message" [class]="t.class"></app-toast-message>
</div>
